import { zeroNumberFieldStyles } from '@genesislcap/foundation-zero';
import { css, ElementStyles } from '@microsoft/fast-element';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';

export const customNumberFieldStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${zeroNumberFieldStyles(context, definition)}
  input {
    color-scheme: dark;
  }
`;
